module.exports = __webpack_public_path__ + "img/tip-five.e38fd3d5.png";